/**
 * @name: systemManagement.js
 * @description: 系统管理路由
 * @author: 于海威
 * @create: 2020/08/07 17:15:51
 * @update: 2020/08/07 17:15:51
 */

export default [
  {
    path: '/system/user/list',
    name: 'userManagement',
    component: () => import('@/views/system/user/List'),
    meta: {
      title: '用户管理'
    }
  },
  {
    path: '/system/user/add',
    name: 'userAdd',
    component: () => import('@/views/system/user/Add'),
    meta: {
      title: '添加用户',
      parentRoutePath: 'userManagement'
    }
  },
  {
    path: '/system/config/list',
    name: 'config',
    component: () => import('@/views/system/config/List'),
    meta: {
      title: '系统配置'
    }
  },
  {
    path: '/system/dictionary/list',
    name: 'dictionary',
    component: () => import('@/views/system/dictionary/List'),
    meta: {
      title: '数据字典'
    }
  },
  {
    path: '/system/distributionchannel/list',
    name: 'distributionChannel',
    component: () => import('@/views/system/distributionChannel/List'),
    meta: {
      title: '销售渠道管理'
    }
  },
  {
    path: '/system/jurisdiction/list',
    name: 'jurisdiction',
    component: () => import('@/views/system/jurisdiction/List'),
    meta: {
      title: '权限管理'
    }
  },
  {
    path: '/system/operationmanual/list',
    name: 'operationmanual',
    component: () => import('@/views/system/operationManual/List'),
    meta: {
      title: '操作手册管理'
    }
  },
  {
    path: '/system/operationlog/list',
    name: 'operationlog',
    component: () => import('@/views/system/operationLog/List'),
    meta: {
      title: '操作日志'
    }
  },
  {
    path: '/system/role/list',
    name: 'roleList',
    component: () => import('@/views/system/role/List'),
    meta: {
      title: '角色管理'
    }
  },
  {
    path: '/system/role/add',
    name: 'roleAdd',
    component: () => import('@/views/system/role/Add'),
    meta: {
      title: '新增角色',
      parentRoutePath: 'roleList'
    }
  },
  {
    path: '/system/version/list',
    name: 'versionList',
    component: () => import('@/views/system/version/List'),
    meta: {
      title: '版本管理'
    }
  },
  {
    path: '/system/version/add',
    name: 'versionAdd',
    component: () => import('@/views/system/version/Add'),
    meta: {
      title: '添加版本',
      parentRoutePath: 'versionList'
    }
  }
];
